import Vue from 'vue';
import { mapState } from 'vuex';
import ImageMagnifier from '@/components/ImageMagnifier.vue';
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
Vue.use(VueViewer);
export default Vue.extend({
    components: { ImageMagnifier },
    props: {
        showThumbnails: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapState('productModule', ['currentProduct', 'currentVariant']),
        product() {
            return this.currentProduct;
        },
    },
    data() {
        return {
            selectedImgUrl: '',
            selectedImgIndex: 0,
            isLeftDisabled: true,
            isRightDisabled: false,
        };
    },
    mounted() {
        /* load all image before check the buttons availability */
        const images = this.$refs.scrollContainer.querySelectorAll('img');
        let loadedCount = 0;
        const checkAllLoaded = () => {
            if (++loadedCount === images.length) {
                this.$nextTick(() => {
                    this.checkScrollButtons();
                });
            }
        };
        images.forEach(img => {
            if (img.complete)
                checkAllLoaded();
            else
                img.addEventListener('load', checkAllLoaded);
        });
        this.$refs.scrollContainer.addEventListener("scroll", this.checkScrollButtons);
        window.addEventListener("resize", this.checkScrollButtons);
    },
    beforeDestroy() {
        const container = this.$refs.scrollContainer;
        if (container) {
            container.removeEventListener("scroll", this.checkScrollButtons);
        }
        window.removeEventListener("resize", this.checkScrollButtons);
    },
    created() {
        this.updateProductGalleryByVariant();
    },
    methods: {
        scrollLeft() {
            const container = this.$refs.scrollContainer;
            if (!container)
                return;
            const scrollAmount = container.clientWidth * 0.8;
            container.scrollBy({
                left: -scrollAmount,
                behavior: "smooth",
            });
            setTimeout(this.checkScrollButtons, 300);
        },
        scrollRight() {
            const container = this.$refs.scrollContainer;
            if (!container)
                return;
            const scrollAmount = container.clientWidth * 0.8;
            container.scrollBy({
                left: scrollAmount,
                behavior: "smooth",
            });
            setTimeout(this.checkScrollButtons, 300);
        },
        checkScrollButtons() {
            const container = this.$refs.scrollContainer;
            if (!container)
                return;
            this.isLeftDisabled = container.scrollLeft <= 1;
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            this.isRightDisabled = container.scrollLeft >= maxScrollLeft - 1;
        },
        onThumbnailSelect(image, index) {
            this.selectedImgUrl = image.url;
            this.selectedImgIndex = index;
        },
        updateProductGalleryByVariant() {
            if (this.currentVariant.images.length) {
                this.selectedImgUrl = this.currentVariant.coverImage.url;
            }
            else if (this.currentProduct.content.media.length) {
                this.selectedImgUrl = this.currentProduct.content.media[0].url;
            }
            else {
                this.selectedImgUrl = this.currentVariant.coverImage.url;
            }
        },
        showImageViewer() {
            this.$viewerApi({
                options: {
                    className: 'img-preview',
                    toolbar: true,
                    url: 'url',
                    initialViewIndex: this.selectedImgIndex,
                    slideOnTouch: true,
                    zoomOnTouch: true,
                    zoomOnWheel: true,
                    toggleOnDblclick: false,
                },
                images: this.currentVariant.images.length
                    ? this.currentVariant.images
                    : this.currentProduct.content.media,
            });
        },
    },
    watch: {
        currentVariant() {
            this.updateProductGalleryByVariant();
        },
    },
});
